import { gql } from "@apollo/client";

export const GET_ARCHIVOS_PRESUPUESTOS = gql`
query GetArchivosGestionPresupuestos($idEvaluacion: Int!) {
    archivosGestionPresupuestos(idEvaluacion: $idEvaluacion) {
        idTransferenciaParticulares
        transferenciaParticulares {
            contentType
            titulo
            archivo
            extension
            fechaAlta
        }
        idPresupuestoAutorizado
        presupuestoAutorizado {
            contentType
            titulo
            archivo
            extension
            fechaAlta
        }
    }
}
`;

export const adaptArchivos = (archivosGestionPresupuestos) => {
  return {
    idTransferenciaParticulares: archivosGestionPresupuestos?.idTransferenciaParticulares,
    transferenciaParticulares: !!archivosGestionPresupuestos?.transferenciaParticulares?.titulo ? {
      contentType: archivosGestionPresupuestos?.transferenciaParticulares?.contentType,
      titulo: archivosGestionPresupuestos?.transferenciaParticulares?.titulo,
      archivo: archivosGestionPresupuestos?.transferenciaParticulares?.archivo,
      extension: archivosGestionPresupuestos?.transferenciaParticulares?.extension
    } : null,
    idPresupuestoAutorizado: archivosGestionPresupuestos?.idPresupuestoAutorizado,
    presupuestoAutorizado: !!archivosGestionPresupuestos?.presupuestoAutorizado?.titulo ? {
      contentType: archivosGestionPresupuestos?.presupuestoAutorizado?.contentType,
      titulo: archivosGestionPresupuestos?.presupuestoAutorizado?.titulo,
      archivo: archivosGestionPresupuestos?.presupuestoAutorizado?.archivo,
      extension: archivosGestionPresupuestos?.presupuestoAutorizado?.extension
    } : null
  };
};